export default {
    "types": {
        "1": {
            "showName": "Карта создана"
        },
        "10": {
            "showName": "Постановка KPI"
        },
        "20": {
            "showName": "Постановка KPI завершена"
        },
        "30": {
            "showName": "Корректировка KPI"
        },
        "40": {
            "showName": "Корректировка KPI завершена"
        },
        "50": {
            "showName": "Промежуточная оценка"
        },
        "60": {
            "showName": "Промежуточная оценка завершена"
        },
        "70": {
            "showName": "Подведение итогов"
        },
        "190": {
            "showName": "Возвращено на доработку"
        },
        "200": {
            "showName": "Карта завершена"
        }
    }
}